'use client';
import React from 'react';
import { Toaster } from 'sonner';

export default function AppToaster() {
  return (
    <Toaster
      position="bottom-right"
      duration={3000}
      toastOptions={{
        classNames: {
          toast: 'rounded-xl border border-border bg-card text-card-foreground shadow-lg',
          description: 'text-muted-foreground',
        },
      }}
    />
  );
}